<div class="header"
     *ngIf="!(loading | async) && !!(selected | async)">
    <muni-gameday-treasury-ticker [treasury]="selected | async">
    </muni-gameday-treasury-ticker>
</div>
<div class="header"
     *ngIf="!(loading | async) && !(selected | async)">
     No Data Available
</div> 
<div class="header"
     *ngIf="loading | async">
     Loading...
</div> 